import React from 'react';

// The sticker colour names (server: models/VesselStickerMapping ALLOWED_COLORS) and how each is painted.
export const COLOR_SWATCH: Record<string, string> = {
  red:    "#ef4444",
  orange: "#f97316",
  yellow: "#facc15",
  green:  "#22c55e",
  blue:   "#3b82f6",
  purple: "#a855f7",
  pink:   "#ec4899",
  brown:  "#92400e",
  grey:   "#6b7280",
  black:  "#111827",
  white:  "#ffffff",
  teal:   "#14b8a6",
};

/** A vessel's sticker colour as a dot and its name; nothing for none or a name outside the palette (D157.3). */
export function StickerColorDot({ color }: { color?: string | null }) {
  if (!color || !Object.prototype.hasOwnProperty.call(COLOR_SWATCH, color)) return null;
  return (
    <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-xs text-slate-600" title={`Sticker colour: ${color}`}>
      <span
        aria-hidden="true"
        className="inline-block h-2.5 w-2.5 rounded-full border border-slate-300"
        style={{ backgroundColor: COLOR_SWATCH[color] }}
      />
      <span className="capitalize">{color}</span>
    </span>
  );
}
